"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _require = require("./virtual-hyperscript-svg");

var svg = _require.svg;
var SupportedSvgTags = _require.SupportedSvgTags;

var _require2 = require("./render-dom");

var makeDOMDriver = _require2.makeDOMDriver;

var _require3 = require("./render-html");

var makeHTMLDriver = _require3.makeHTMLDriver;

var mockDOMSource = require("./mock-dom-source");
var h = require("./virtual-hyperscript");
var hh = require("hyperscript-helpers")(h);

var CycleDOM = _extends({
  /**
   * A factory for the DOM driver function. Takes a `container` to define the
   * target on the existing DOM which this driver will operate on. The output
   * ("source") of this driver is a collection of Observables queried with:
   * `DOMSource.select(selector).events(eventType)` returns an Observable of
   * events of `eventType` happening on the element determined by `selector`.
   * Just `DOMSource.select(selector).observable` returns an Observable of the
   * DOM element matched by the given selector. Also,
   * `DOMSource.select(':root').observable` returns an Observable of DOM element
   * corresponding to the root (or container) of the app on the DOM. The
   * `events()` function also allows you to specify the `useCapture` parameter
   * of the event listener. That is, the full function signature is
   * `events(eventType, useCapture)` where `useCapture` is by default `false`.
   *
   * @param {(String|HTMLElement)} container the DOM selector for the element
   * (or the element itself) to contain the rendering of the VTrees.
   * @return {Function} the DOM driver function. The function expects an
   * Observable of VTree as input, and outputs the source object for this
   * driver, containing functions `select()` and `dispose()` that can be used
   * for debugging and testing.
   * @param {Object} options an options object containing additional
   * configurations. The options object is optional. These are the parameters
   * that may be specified:
   *   - `onError`: a callback function to handle errors. By default it is
   *   `console.error`.
   * @function makeDOMDriver
   */
  makeDOMDriver: makeDOMDriver,

  /**
   * A factory for the HTML driver function.
   *
   * @return {Function} the HTML driver function. The function expects an
   * Observable of Virtual DOM elements as input, and outputs an Observable of
   * strings as the HTML renderization of the virtual DOM elements.
   * @function makeHTMLDriver
   */
  makeHTMLDriver: makeHTMLDriver,

  /**
   * A shortcut to [virtual-hyperscript](
   * https://github.com/Matt-Esch/virtual-dom/tree/master/virtual-hyperscript).
   * This is a helper for creating VTrees in Views.
   * @name h
   */
  h: h

}, hh, {

  /**
   * An adapter around virtual-hyperscript `h()` to allow JSX to be used easily
   * with Babel. Place the [Babel configuration comment](
   * http://babeljs.io/docs/advanced/transformers/other/react/) `@jsx hJSX` at
   * the top of the ES6 file, make sure you import `hJSX` with
   * `import {hJSX} from '@cycle/dom'`, and then you can use JSX to create
   * VTrees.
   *
   * Note that to pass in custom attributes, e.g. data-*, you must use the
   * attributes key like `<tag attributes={{'data-custom-attr': 'foo'}} />`.
   *
   * @name hJSX
   */
  hJSX: function hJSX(tag, attrs) {
    var isSvgTag = SupportedSvgTags.indexOf(tag) !== -1;
    var domHandler = isSvgTag ? svg : h;

    for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      children[_key - 2] = arguments[_key];
    }

    return domHandler(tag, attrs, children);
  },

  /**
   * A shortcut to the svg hyperscript function.
   * @name svg
   */
  svg: svg,

  /**
   * A testing utility which aids in creating a queryable collection of
   * Observables. Call mockDOMSource giving it an object specifying selectors,
   * eventTypes and their Observables, and get as output an object following the
   * same format as the DOM Driver's source. Example:
   *
   * ```js
   * const domSource = mockDOMSource({
   *   '.foo': {
   *     'click': Rx.Observable.of({target: {}}),
   *     'mouseover': Rx.Observable.of({target: {}}),
   *   },
   *   '.bar': {
   *     'scroll': Rx.Observable.of({target: {}}),
   *     observable: Rx.Observable.of({tagName: 'div'}),
   *   }
   * });
   *
   * // Usage
   * const click$ = domSource.select('.foo').events('click');
   * const element$ = domSource.select('.bar').observable;
   * ```
   *
   * @param {Object} mockedSelectors an object where keys are selector strings
   * and values are objects. Those nested objects have eventType strings as keys
   * and values are Observables you created.
   * @return {Object} fake DOM source object, containing a function `select()`
   * which can be used just like the DOM Driver's source. Call
   * `select(selector).events(eventType)` on the source object to get the
   * Observable you defined in the input of `mockDOMSource`.
   * @function mockDOMSource
   */
  mockDOMSource: mockDOMSource
});

module.exports = CycleDOM;
/**
 * Shortcuts to
 * [hyperscript-helpers](https://github.com/ohanhi/hyperscript-helpers).
 * This is a helper for writing virtual-hyperscript. Create virtual DOM
 * elements with `div('.wrapper', [ h1('Header') ])` instead of
 * `h('div.wrapper', [ h('h1', 'Header') ])`.
 * @name hyperscript-helpers
 */


/*****************
 ** WEBPACK FOOTER
 ** ./~/@cycle/dom/lib/cycle-dom.js
 ** module id = 2
 ** module chunks = 0
 **/